import React from 'react';
import _ from 'lodash';
import {
  AuthRoles,
  readableRegistrationState,
  readableRegistrationStatus,
  Roles,
} from '../../config';
import { LanguagesEnum } from '../../config/languages';
import ActionsBlock from './components/datatable/ActionsBlock';
import * as DateUtils from 'utils/dates';

const CONFIGURATION = {};

export const Translations = {
  page_title: {
    [LanguagesEnum.Greek]: 'Applicants',
    [LanguagesEnum.English]: 'Applicants',
  },
  add_applicant: {
    [LanguagesEnum.Greek]: 'Προσθήκη αιτητή',
    [LanguagesEnum.English]: 'Add applicant',
  },
  table_title: {
    [LanguagesEnum.Greek]: 'Manage Applicants',
    [LanguagesEnum.English]: 'Manage Applicants',
  },
  resend_verification_link: {
    [LanguagesEnum.Greek]: 'Resend Verification Link',
    [LanguagesEnum.English]: 'Resend Verification Link',
  },
};

export const TableColumns = (ROLE: Roles) => {
  return [
    {
      label: '#',
      id: 'applicant_id',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'VAT Number',
      id: 'vat_num',
      align: 'left',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Username',
      id: 'username',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Name',
      id: 'applicant_name',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    ...(ROLE !== Roles.Agent
      ? [
          {
            label: 'Agent ID',
            id: 'intermidiary',
            render: (rowIndex: number, cellValue: any, columnIndex: number) => (
              <React.Fragment>{cellValue}</React.Fragment>
            ),
            inData: true,
          },
        ]
      : []),
    {
      label: 'Latest Reg. Commencement Date',
      id: 'latest_reg_commencement_date',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>
          {cellValue ? DateUtils.formatDate(cellValue) : '-'}
        </React.Fragment>
      ),
      inData: false,
    },
    {
      label: 'Latest Reg. Status/State',
      id: 'latest_reg_status_state',
      render: (rowIndex: number, cellValue: string, columnIndex: number) => (
        <React.Fragment>
          {cellValue
            ? `${
                readableRegistrationStatus[
                  Number.parseInt(cellValue.split('.')[0])
                ]
              }/${_.get(
                readableRegistrationState,
                cellValue.split('.')[1],
                '-'
              )}`
            : '-'}
        </React.Fragment>
      ),
      inData: false,
    },
    {
      label: 'Latest VAT Return Period',
      id: 'latest_vat_return_period',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue ?? '-'}</React.Fragment>
      ),
      inData: false,
    },
    {
      label: 'Is Verified',
      id: 'isVerified',
      render: (rowIndex: number, cellValue: boolean, columnIndex: number) => (
        <React.Fragment>{cellValue ? 'Yes' : 'No'}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Actions',
      align: 'center',
      id: 'actions',
      render: (
        rowIndex: number,
        cellValue: any,
        columnIndex: number,
        data: any
      ) => (
        <ActionsBlock
          rowIndex={rowIndex}
          applicant_id={data[rowIndex].applicant_id}
          verified={data[rowIndex].isVerified}
          ROLE={ROLE}
          vatNumber={data[rowIndex].vat_num}
        />
      ),
      inData: false,
    },
  ];
};

export default CONFIGURATION;
